module.exports = __webpack_public_path__ + "static/media/schody44 - schody drewniane nakladane.f21dbef2.jpg";